import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { ReactElement, Ref, forwardRef } from 'react';
import FileListItem from './FileListItem';
import { Box } from '@mui/material';

const Transition = forwardRef(function Transition( props: TransitionProps & { children: ReactElement }, ref: Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export type AuxFilesFullScreenDialogType = {
  open: boolean,
  handleClose: () => void,
  filesUrl: Array<string>
}

export default function AuxFilesFullScreenDialog({ open, handleClose, filesUrl }: AuxFilesFullScreenDialogType) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Arquivos auxiliares
          </Typography>
        </Toolbar>
      </AppBar>
      <Box m={2} >
        {filesUrl.map((fileUrl) => <FileListItem fileUrl={fileUrl}/>)}
      </Box>
    </Dialog>
  );
}